import React from "react";

const DataContext = React.createContext({
    error: undefined,
    setError: () => {},
    loading: false,
    setLoading: () => {},
    location: {},
    setLocation: () => {},
    availableServices: [],
    setAvailableServices: () => {},
    serviceType: "",
    setServiceType: () => {},
    additionalOptions: "",
    setAdditionalOptions: () => {},
    selectedPhone: 0,
    setSelectedPhone: () => {},
    selectedTv: 0,
    setSelectedTv: () => {},
    formSubmitted: false,
    setFormSubmitted: () => {},
    resetData: () => {},
    selectedAttributes: [],
    setSelectedAttributes: () => [],
    inHelp: {},
    setInHelp: () => {},
    isOpen: false,
    setIsOpen: () => {},
    closeApp: () => {},
    sortedServiceFeatures: [],
    setSortedServiceFeatures: () => {},
    isSatellite: false,
    setIsSatellite: () => {},
    triggerInputHouseNumber: false,
    setTriggerInputHouseNumber: () => {},
});

export default DataContext;
